import { Helpdesk } from 'models/Helpdesk/helpdesk.model';
import { Product } from 'models/Product/product.model';
import React, { createContext, useState, useContext, useEffect } from 'react';

// Define the type for the context
type MyContextType = {
  helpDeskData: Helpdesk | null;
  productData: Product | undefined;
  setProductData: (data: Product | undefined) => void;
  setHelpDeskData: (data: Helpdesk | null) => void;
  isHelpDeskOpen: boolean;
  setIsHelpDeskOpen: (state: boolean) => void;
  helpDeskLoading: boolean;
  setHelpDeskLoading: (state: boolean) => void;
};

// Create the context
export const HelpDeskContext = createContext<MyContextType>({
  helpDeskData: null,
  productData: undefined,
  setProductData: (data: Product | undefined) => {},
  setHelpDeskData: (data: Helpdesk | null) => {},
  isHelpDeskOpen: false,
  setIsHelpDeskOpen: (state: boolean) => {},
  setHelpDeskLoading: (state: boolean) => {},
  helpDeskLoading: false,
});

// Create a custom hook to access the context
export const useHelpDeskContext = () => {
  const context = useContext(HelpDeskContext);
  if (!context) {
    throw new Error('useMyContext must be used within a MyContextProvider');
  }
  return context;
};

// Create the context provider component
export const HelpDeskProvider: React.FC = ({ children }) => {
  const [helpDeskData, setHelpDeskData] = useState<Helpdesk | null>(null);
  const [isHelpDeskOpen, setIsHelpDeskOpen] = useState<boolean>(false);
  const [productData, setProductData] = useState<Product | undefined>();
  const [helpDeskLoading, setHelpDeskLoading] = useState<boolean>(false);

  return (
    <HelpDeskContext.Provider
      value={{
        helpDeskData,
        setHelpDeskData,
        isHelpDeskOpen,
        setIsHelpDeskOpen,
        productData,
        setProductData,
        helpDeskLoading,
        setHelpDeskLoading,
      }}>
      {children}
    </HelpDeskContext.Provider>
  );
};
